const backendUrl = process.env.VUE_APP_BACKEND_URL;
const yandexMetricId = process.env.VUE_APP_YANDEX_METRIC_ID;

export  {backendUrl, yandexMetricId};